import { Collection } from 'firestorter';
import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

/**
 * Class representing a Chat Channel unread count for given user.
 *
 * @class ChannelUnreadCount
 * @extends BaseDocument
 */
class ChannelUnreadCount extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.CHANNEL_UNREAD_COUNT}/${id}`, opts);
  }

  /**
   * Get unread count of the channel for the user.
   * @return {string}
   */
  get unreadCount() {
    return this.data.unreadCount;
  }

  /**
   * userId the unread count is for.
   * @return {string}
   */
  get userId() {
    return this.data.userId;
  }

  /**
   * channelId the unread count is for.
   * @return {string}
   */
  get channelId() {
    return this.data.channelId;
  }

  // Methods
  increaseUnreadCount = () => (
    this.updateFields({
      unreadCount: 1,
    })
  );

  setUnreadCountToZero = () => (
    this.updateFields({
      unreadCount: 0,
    })
  );

  static async getUnreadCounts(userId) {
    const unreadCountList = new Collection(() => `/${CollectionName.CHANNEL_UNREAD_COUNT}`, {
      createDocument: (src, opts) => new ChannelUnreadCount(src.id, opts),
      query: (ref) => ref
        .where('userId', '==', userId)
        .where('unreadCount', '>', 0),
    });

    await unreadCountList.fetch();
    return unreadCountList;
  }

  static async getUnreadCountForChannelByUser(userId, channelId) {
    const unreadCountList = new Collection(() => `/${CollectionName.CHANNEL_UNREAD_COUNT}`, {
      createDocument: (src, opts) => new ChannelUnreadCount(src.id, opts),
      query: (ref) => ref.where('userId', '==', userId).where('channelId', '==', channelId),
    });

    await unreadCountList.fetch();
    return unreadCountList.docs[0]?.data?.unreadCount || 0;
  }

  static async getUnreadCountDocForChannelByUser(userId, channelId) {
    const unreadCountList = new Collection(() => `/${CollectionName.CHANNEL_UNREAD_COUNT}`, {
      createDocument: (src, opts) => new ChannelUnreadCount(src.id, opts),
      query: (ref) => ref.where('userId', '==', userId).where('channelId', '==', channelId),
    });

    await unreadCountList.fetch();
    return unreadCountList.docs[0];
  }
}

export default ChannelUnreadCount;
